import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:writeclass@isu.edu">writeclass@isu.edu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/idaho-state/siteComponents/helpContent.js